
import React from 'react';

export default function Process() {
  const steps = [
    {
      number: '01',
      title: 'Initial Consultation',
      description:
        'We begin with a comprehensive discussion of your financial situation, tax concerns, and long-term goals to understand your unique needs.',
      team: [
        'https://public.readdy.ai/ai/img_res/a21a8a690e484e1dba77203c2650c2ce.jpg',
        'https://readdy.ai/api/search-image?query=professional%20tax%20advisor%20headshot%20portrait%20experienced%20knowledgeable%20expert%20clean%20simple%20background&width=80&height=80&seq=team-002&orientation=squarish',
      ],
    },
    {
      number: '02',
      title: 'Document Collection',
      description:
        'Our team guides you through gathering all necessary financial documents, tax forms, and records with a detailed checklist.',
      team: [
        'https://readdy.ai/api/search-image?query=professional%20accountant%20headshot%20portrait%20organized%20detail%20oriented%20expert%20clean%20simple%20background&width=80&height=80&seq=team-003&orientation=squarish',
      ],
    },
    {
      number: '03',
      title: 'Strategy Development',
      description:
        'We analyze your financial data and develop a customized tax strategy that maximizes deductions, credits, and savings.',
      team: [
        'https://readdy.ai/api/search-image?query=professional%20financial%20strategist%20headshot%20portrait%20analytical%20expert%20advisor%20clean%20simple%20background&width=80&height=80&seq=team-004&orientation=squarish',
        'https://readdy.ai/api/search-image?query=professional%20tax%20planner%20headshot%20portrait%20strategic%20thinking%20expert%20clean%20simple%20background&width=80&height=80&seq=team-005&orientation=squarish',
      ],
    },
    {
      number: '04',
      title: 'Implementation',
      description:
        'We execute your tax strategy with precision, preparing and filing all required returns while ensuring full compliance.',
      team: [
        'https://readdy.ai/api/search-image?query=professional%20tax%20preparer%20headshot%20portrait%20meticulous%20accurate%20expert%20clean%20simple%20background&width=80&height=80&seq=team-006&orientation=squarish',
      ],
    },
    {
      number: '05',
      title: 'Ongoing Support',
      description:
        'Our relationship continues year-round with quarterly reviews, proactive planning, and immediate support for any concerns.',
      team: [
        'https://readdy.ai/api/search-image?query=professional%20client%20support%20specialist%20headshot%20portrait%20helpful%20responsive%20expert%20clean%20simple%20background&width=80&height=80&seq=team-007&orientation=squarish',
        'https://readdy.ai/api/search-image?query=professional%20tax%20consultant%20headshot%20portrait%20dedicated%20supportive%20expert%20clean%20simple%20background&width=80&height=80&seq=team-008&orientation=squarish',
      ],
    },
  ];

  return (
    <section id="process" className="py-24 px-8 bg-[#0a1628] relative overflow-hidden">
      {/* Background accent */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#00e5c7]/30 to-transparent"></div>
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#00e5c7]/30 to-transparent"></div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 mb-4 justify-center">
            <div className="w-8 h-px bg-[#00e5c7]"></div>
            <span className="text-[#00e5c7] text-xs uppercase tracking-[0.3em] font-semibold">
              How We Work
            </span>
            <div className="w-8 h-px bg-[#00e5c7]"></div>
          </div>
          <h2
            className="text-4xl md:text-5xl font-bold text-white"
            style={{ fontFamily: "'Outfit', sans-serif" }}
          >
            Our Proven Process
          </h2>
        </div>

        <div className="relative">
          <div
            className="flex overflow-x-auto pb-8 gap-6 scrollbar-hide"
            style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
          >
            {steps.map((step, index) => (
              <div
                key={index}
                className="flex-shrink-0 w-80 bg-white/5 backdrop-blur-sm rounded-lg p-8 border border-white/10 hover:border-[#00e5c7]/30 transition-all duration-300 relative group"
              >
                {/* Step number accent */}
                <div className="absolute top-0 left-8 w-12 h-1 bg-gradient-to-r from-[#00e5c7] to-transparent rounded-b"></div>

                <div
                  className="text-[#00e5c7] text-6xl font-bold mb-4 leading-none opacity-30 group-hover:opacity-60 transition-opacity"
                  style={{ fontFamily: "'Outfit', sans-serif" }}
                >
                  {step.number}
                </div>
                <h3
                  className="text-lg font-bold text-white mb-4"
                  style={{ fontFamily: "'Outfit', sans-serif" }}
                >
                  {step.title}
                </h3>
                <p className="text-sm text-white/60 leading-relaxed mb-6">{step.description}</p>

                <div className="flex -space-x-3">
                  {step.team.map((avatar, idx) => (
                    <div
                      key={idx}
                      className="w-10 h-10 rounded-full border-2 border-[#0a1628] overflow-hidden"
                    >
                      <img
                        src={avatar}
                        alt={`Team member ${idx + 1}`}
                        className="w-full h-full object-cover object-top"
                        onError={(e) => {
                          // Fallback to a placeholder image if the avatar fails to load
                          const target = e.target as HTMLImageElement;
                          target.src =
                            'https://via.placeholder.com/80?text=Avatar';
                        }}
                      />
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div className="absolute right-0 top-0 bottom-8 w-24 bg-gradient-to-l from-[#0a1628] to-transparent pointer-events-none hidden md:block"></div>
        </div>
      </div>
    </section>
  );
}
